var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueAdult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1842",
    "data-name": "Group 1842",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 24.943,
    viewBox: "0 0 31 24.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4306",
    "data-name": "Path 4306",
    d: "M26.632,30.265A4.632,4.632,0,1,0,22,25.632a4.632,4.632,0,0,0,4.632,4.632Zm0-7.483a2.851,2.851,0,1,1-2.851,2.851A2.851,2.851,0,0,1,26.632,22.782Z",
    transform: "translate(-16.656 -19.218)",
    fill: "#536dfe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4307",
    "data-name": "Path 4307",
    d: "M58.632,25.265A4.632,4.632,0,1,0,54,20.632,4.632,4.632,0,0,0,58.632,25.265Zm0-7.483a2.851,2.851,0,1,1-2.851,2.851A2.851,2.851,0,0,1,58.632,17.782Z",
    transform: "translate(-37.252 -16)",
    fill: "#536dfe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4308",
    "data-name": "Path 4308",
    d: "M18.581,50H15.374A8.381,8.381,0,0,0,7,58.374v3.563a.891.891,0,0,0,.891.891H26.064a.891.891,0,0,0,.891-.891V58.374A8.381,8.381,0,0,0,18.581,50Zm6.592,11.046H8.782V58.374a6.6,6.6,0,0,1,6.592-6.592h3.207a6.6,6.6,0,0,1,6.592,6.592Z",
    transform: "translate(-7 -37.885)",
    fill: "#536dfe"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4309",
    "data-name": "Path 4309",
    d: "M66.891,45a.891.891,0,1,0,0,1.782,6.919,6.919,0,0,1,7.3,6.834v2.43h-7.3a.891.891,0,1,0,0,1.782h8.2a.891.891,0,0,0,.891-.891V53.616C75.977,48.207,71.345,45,66.891,45Z",
    transform: "translate(-44.977 -34.667)",
    fill: "#536dfe"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueAdult);
export default __webpack_public_path__ + "static/media/blue-adult.d0527911.svg";
export { ForwardRef as ReactComponent };